import { useCallback } from 'react';
import { CreateTitleV2 } from '@warehouse/graphql';
import { CreateTitleResult as RepoCreateTitleResult } from '@warehouse/title/core';
import { titleRepositorySingleton } from '@warehouse/title/infra';

interface CreateTitleOptions {
	variables: {
		input: CreateTitleV2;
	};
}

interface CreateTitleResult {
	data?: {
		createTitleV2: {
			title: {
				uuid: string;
			};
			edit?: {
				uuid: string;
			};
		};
	};
}

function useCreateTitleV2() {
	const createTitle = useCallback(async (options: CreateTitleOptions): Promise<CreateTitleResult> => {
		const { input } = options.variables;
		const repo = titleRepositorySingleton.get();

		const result: RepoCreateTitleResult = await repo.createTitle({
			metadata: input.metadata,
			dryRun: input.dryRun ?? false,
			primaryEdit: input.primaryEdit ?? undefined,
		});

		return {
			data: {
				createTitleV2: {
					title: {
						uuid: result.title.uuid,
					},
					edit: result.edit ? { uuid: result.edit.uuid } : undefined,
				},
			},
		};
	}, []);

	return [createTitle] as const;
}

export default useCreateTitleV2;
